<template lang="pug">
div
  table
    tr
      th &beta;
      td
        log-scale-range(v-model="params.beta", :min="0", :max="2.e+8")
    tr
      th b<sub>0</sub>
      td
        range-slider(v-model.number="params.b0", min="0", max="5.e-5", step="1.e-8", style="width: 100%;")
    tr
      th A
      td
        log-scale-range(v-model.number="params.a", :min="0", :max="1.e4")
    tr
      th bias
      td
        log-scale-range(v-model.number="params.bias", :min="-0.5", :max="0.5", :a="1.e-8")
</template>

<script lang="ts">
import { Vue, Component, Prop } from "vue-property-decorator";
import { Params } from "@/modules/SspDataModule";

@Component
export default class extends Vue {
  @Prop({ required: true })
  params!: Params["sdssTrueColor"]

  get logBeta() {
    return Math.log(this.params.beta)
  }
  set logBeta(beta: number) {
    this.params.beta = Math.exp(beta)
  }
}
</script>


<style lang="scss" scoped>
table {
  width: 100%;
}

th {
  width: 20%;
}

.slider {
  width: 100%;
}
</style>